import { CalendarDots } from "@phosphor-icons/react";
import { useMemo } from "react";
import Pill from "../../common/Pill/Pill";

// Helper function to format due date
const formatDueDate = (dateString) => {
  if (!dateString) return null;

  const dueDate = new Date(dateString);
  const today = new Date();

  const dueDateStart = new Date(dueDate.getFullYear(), dueDate.getMonth(), dueDate.getDate());
  const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());

  const month = dueDate.getMonth() + 1;
  const day = dueDate.getDate();

  return {
    text: `Due ${month}/${day}`,
    isOverdue: dueDateStart < todayStart,
  };
};

const DueDatePill = ({ dueDate }) => {
  const dueDateInfo = useMemo(() => formatDueDate(dueDate), [dueDate]);

  if (!dueDate) return null;

  return (
    <Pill
      text={dueDateInfo?.text}
      textColor={dueDateInfo?.isOverdue ? "#DC2626" : "#667085"}
      backgroundColor={dueDateInfo?.isOverdue ? "#FEE2E2" : "#EAECF0"}
      leftIcon={<CalendarDots size={14} color={dueDateInfo?.isOverdue ? "#DC2626" : "#344054"} />}
    />
  );
};

export default DueDatePill;
